<template>

  <div>

   
      <b-modal hide-footer v-model="IsShown" modal-class="showDetails ask-for-number-modal " id="assPhoneModal" size="md" header-close-variant="danger" centered>
         <form @submit.prevent="send">
          <div>
            <p class="text-center">عزيزي العميل، لنتمكن من متابعة طلبك رجاء استكمال البيانات.</p>
            <b-row>
              <b-col sm="3">
                <label for="name">الاسم:</label>
              </b-col>
        
              <b-col sm="9" class="mb-2">
                <b-form-input required  placeholder="الاسم" v-model="info.name"> </b-form-input>
              </b-col>
              <b-col sm="3">
                <label for="name">رقم الهاتف:</label>
              </b-col>
              <b-col sm="9" class="mb-2" >
                <b-form-input required placeholder="رقم الهاتف" v-model="info.phone"> </b-form-input>
              </b-col>
              <b-col sm="3" >
                <label for="name">العنوان:</label>
              </b-col>
              <b-col sm="9" >
                <b-form-input required placeholder="العنوان" v-model="info.address"> </b-form-input>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12" class="mb-2 -2 text-left mt-2">
                  <b-button class="bg-red color-white no-shadow no-border ml-1 mr-1 "  @click="closeModal()">إلغاء</b-button>
                  <b-button class="bg-primary-dark color-white no-border ml-1 mr-1" type="submit">أرسال</b-button>
              </b-col>
            </b-row>
          </div>
         </form>

      </b-modal>

    
  <!-- <b-modal v-model="IsShown" modal-class="showDetails ask-for-number-modal " id="assPhoneModal" size="md" header-close-variant="danger" centered >
      
      <div>
        <p class="text-center">عزيزي العميل، لنتمكن من متابعة طلبك رجاء استكمال البيانات.</p>
        <b-row>
          <b-col sm="3">
            <label for="name">الاسم:</label>
          </b-col>
          <b-col sm="9" class="mb-2">
            <b-form-input  placeholder="الاسم" v-model="info.name"> </b-form-input>
          </b-col>
          <b-col sm="3">
            <label for="name">رقم الهاتف:</label>
          </b-col>
          <b-col sm="9" class="mb-2" >
             <b-form-input placeholder="رقم الهاتف" v-model="info.phone"> </b-form-input>
          </b-col>
          <b-col sm="3" >
            <label for="name">العنوان:</label>
          </b-col>
          <b-col sm="9" >
             <b-form-input placeholder="العنوان" v-model="info.address"> </b-form-input>
          </b-col>
        </b-row>

        
      </div>
      <template #modal-footer>
          <div class="d-flex">
            <b-button class="bg-red color-white no-shadow no-border ml-1 mr-1"  @click="closeModal()">إلغاء</b-button>
            <b-button class="bg-primary-dark color-white no-border ml-1 mr-1" @click="send()">أرسال</b-button>
            
          </div>
      </template>
    </b-modal> -->
  </div>
</template>
<script>
import {mapState, mapMutations, mapActions} from 'vuex'
export default {
  name:'AskForPhone',
  computed:{
    ...mapState(['askForPhone'])
  },
  data() {
    return{
      IsShown:false,
      info:{
        phone:"",
        name:"",
        address:""
      },
      loading:{
        main:false
      }
    }
  },
  methods:{
    ...mapMutations(["hideAskPhone", 'setPhone']),
    ...mapActions(["addPhone"]),

    closeModal() {
      this.$bvModal.hide('assPhoneModal')
    },
    async send() {
      await this.setPhone(this.info);
      this.addPhone()
       this.$bvModal.hide('assPhoneModal')
    }
  },
  watch:{
    'IsShown': function() {
      if(this.IsShown) {
         this.$bvModal.show('assPhoneModal')
      } else {
        this.hideAskPhone()
      }
    },
    'askForPhone': function() {
      if(this.askForPhone)  {
        this.IsShown = true
      }
    }
  }
}
</script>
